var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.786,
    height: 11.786,
    viewBox: "0 0 11.786 11.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31,31a.918.918,0,0,1,1.3,0l4.326,4.326L40.954,31a.918.918,0,1,1,1.3,1.3l-4.326,4.326,4.326,4.326a.918.918,0,1,1-1.3,1.3l-4.326-4.326L32.3,42.252a.918.918,0,1,1-1.3-1.3l4.326-4.326L31,32.3A.918.918,0,0,1,31,31Z",
    transform: "translate(-30.734 -30.734)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.034099e3.svg";
export { ForwardRef as ReactComponent };